import {Model} from 'pinia-orm';

export default class CampaignPackageType extends Model {

    static get entity () {
        return 'campaign_package_types';
    }

    static fields () {
        return {
            id: this.uid(),
            translations: this.attr(null),
        }
    }

    static fetch() {
        return axios.get(route('api.manage.companies.campaign-packages.types'))
            .then(res => res.data);
    }
}
